exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-6b988b0c]{border:1px solid;border-color:#ccc!important;border-radius:.5rem;overflow:hidden}.icon-select[data-v-6b988b0c]{padding:8px;display:inline-block;background-color:rgba(195,155,211,.8);border-radius:.5rem}[data-v-6b988b0c] .v-datatable.v-table>tbody{max-height:35vh;min-height:35vh}", ""]);

// exports
